import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../lib/firebase';
import { updateOrganization } from '../../../api/remiApi';
import {
  BrandingFooter,
  BrandingPropertyDetails,
  BrandingSqueezePage,
} from '../../../types/branding';

interface BrandingData {
  colors: {
    primary: string;
    secondary: string;
  };
  logo: {
    url: string;
    width: number;
    height: number;
    placement?: 'header' | 'footer' | 'both';
  };
  favicon?: {
    url?: string;
    width?: number;
    height?: number;
  };
  // Extended branding sections
  teamName?: string;
  brokerageName?: string;
  footer?: BrandingFooter;
  propertyDetails?: BrandingPropertyDetails;
  squeezePage?: BrandingSqueezePage;
}

interface OrgLink {
  key: string;
  value: string;
}

export const useUpdateBranding = () => {
  const updateBranding = async (
    organizationId: string,
    branding: BrandingData,
    orgLinks: OrgLink[]
  ) => {
    if (!organizationId) throw new Error('Organization ID is required');

    try {
      // Try to update branding in tenant document if it exists
      const tenantRef = doc(db, 'tenants', organizationId);
      await updateDoc(tenantRef, {
        branding,
      });
    } catch (error) {
      console.log('No tenant document found, skipping tenant update');
    }

    // Always update organization with branding and links via Remi REST
    const org_links = orgLinks.reduce(
      (acc, link) => ({
        ...acc,
        [link.key]: link.value,
      }),
      {}
    );
    await updateOrganization(organizationId, {
      org_links,
      logoUrl: branding.logo.url,
      faviconUrl: branding.favicon?.url || '',
      branding: {
        primaryColor: branding.colors.primary,
        secondaryColor: branding.colors.secondary,
      },
    });
  };

  return { updateBranding };
};
